<div>
  <div id="googleMap" style="width:100%;height:500px;" scrolling="no" class="mobile-map">
    <iframe src="https://snazzymaps.com/embed/442360" width="100%" height="500px" style="border:none;" ></iframe>
  </div>
</div>
